(function ($) {

    "use strict";

    $.enhancer("arrangementSearchBox", function() {

        const $this = $(this);
        const $query = $this.find("[data-arrangementSearchBox-query]");
        const $location = $this.find("[data-arrangementSearchBox-location]");
        const $remote = $this.find("[data-arrangementSearchBox-remote]");
        const $queryResetButton = $query.siblings("button.input-reset");

        $queryResetButton.on("click", function () {
            setQuery("");
            $query.val("").focus();
        });

        function setQuery(value) {
            $this.trigger("queryChange", [value]);
        }

        function setLocation() {
            // console.log("setLocation: " + $location.val());
            var value = [];
            value.push($location.val());
            $this.trigger("locationChange", [value]);
        }

        function init() {
            setQuery($query.val());
            // setLocation();
            $query.on("change", function () { setQuery($query.val()); });
            $location.on("change", function () { setLocation(); });
            $remote.on("change", function () { setLocation(); });
            $this.on("submit", function (event) { search(event); });
        };

        function search(event) {
            var data = {
                mode : $this.attr("data-mode"),
                query : $query.val(),
                location : $location.val()
            };
            $this.trigger("search", [data]);
            event.preventDefault();
            return false;
        };

        init();

    });

})(jQuery);